import { Link } from 'react-router-dom';

interface CTASectionProps {
  signupEnabled: boolean;
  className?: string;
}

/**
 * CTASection Component
 *
 * Final call-to-action section with animated glow button.
 * Shows "Coming Soon" badge when signup is disabled.
 */
export function CTASection({ signupEnabled, className = '' }: CTASectionProps) {
  return (
    <section className={`landing-section landing-cta ${className}`}>
      <h2 className="landing-cta__title animate-fadeInUp">Ready to Dive Deeper?</h2>
      <p className="landing-cta__description animate-fadeInUp stagger-1">
        {signupEnabled
          ? 'Create your free account and start learning today.'
          : 'New registrations opening soon. Try our free demo in the meantime!'}
      </p>
      {signupEnabled ? (
        <Link to="/signup" className="landing-cta__button animate-pulse-glow animate-fadeInUp stagger-2">
          Create Free Account
        </Link>
      ) : (
        <span className="landing-nav__badge animate-fadeInUp stagger-2" style={{ fontSize: 'var(--cld-font-size-lg)', padding: 'var(--cld-spacing-md) var(--cld-spacing-2xl)' }}>
          Coming Soon
        </span>
      )}
    </section>
  );
}
